var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseIcon',{staticClass:"animate-spin",attrs:{"size":_vm.sizeIcon,"icon":"spinner"}})
}
var staticRenderFns = []

export { render, staticRenderFns }